export default __webpack_public_path__ + "static/media/Availability_Image.c5c77f39.png";